import React, { useState, useCallback, useEffect, useRef } from "react";
import Tempo from "../Tempo";
import Iframe from "../Iframe";
import LessonFile from "../LessonFile";
import LessonTeste from "../LessonTeste";
import { Container } from "./styles";

const LessonAnexo = (props) => {
  const [anexo, setAnexo] = useState("");

  useEffect(() => {
    const formatedAnexo = props.anexo.split("://").pop();

    setAnexo(formatedAnexo);
  }, [props]);

  return (
    <Container>
      {
        {
          video: <Iframe src={anexo} vimeo />,
          youtube: <Iframe src={anexo} youtube />,
          arquivo: <LessonFile src={anexo} />,
          apresentacao: <Iframe src={anexo} google />,
          teste: (
            <LessonTeste
              src={anexo}
              changesTest={props.changesTest}
              teste={props.teste}
              original={props.original || "1"}
              handleTeste={props.handleTeste}
            />
          ),
        }[props.tipo]
      }
    </Container>
  );
};

export default LessonAnexo;
